module.exports = __webpack_public_path__ + "static/fonts/StyleScript-Regular.d6aad0b9.ttf";